module.exports = __webpack_public_path__ + "static/batman-ba01517bf15ea181a1ac0f09fbe79f3c.jpg";